import { AddressType } from '@lmc/ts-common'

export const getAddressTypeOptions = (t: (value: string) => string) => [
  {
    value: AddressType.Main_Permanent_Residence,
    label: t('ADDRESS_TYPE_MAIN_PERMANENT_RESIDENCE'),
  },
  {
    value: AddressType.Other_Permanent_Residence,
    label: t('ADDRESS_TYPE_OTHER_PERMANENT_RESIDENCE'),
  },
  {
    value: AddressType.Temporary_Residence,
    label: t('ADDRESS_TYPE_TEMPORARY_RESIDENCE'),
  },
  {
    value: AddressType['Correspondence_(Non-Residence)'],
    label: t('ADDRESS_TYPE_CORRESPONDENCE_NON_RESIDENCE'),
  },
  {
    value: AddressType.Main_Business_Premises,
    label: t('ADDRESS_TYPE_MAIN_BUSINESS_PREMISES'),
  },
  {
    value: AddressType.Invoice,
    label: t('ADDRESS_TYPE_INVOICE'),
  },
  {
    value: AddressType.Other_Business_Premises,
    label: t('ADDRESS_TYPE_OTHER_BUSINESS_PREMISES'),
  },
  {
    value: AddressType.Safe_Haven_ADDRESS,
    label: t('ADDRESS_TYPE_SAFE_HAVEN_ADDRESS'),
  },
]
